import React, { useEffect } from 'react';
import { ReactComponent as Tools } from '../../assets/icons/tools.svg';
import { ReactComponent as ToolsHover } from '../../assets/icons/tools-hover.svg';
import { ReactComponent as Page } from '../../assets/icons/page.svg';
import { ReactComponent as PageHover } from '../../assets/icons/page-hover.svg';
import Arrow from '../../assets/icons/arrow.svg';
import { ReactComponent as AnnotationIcon } from '../../assets/icons/annotationIcon.svg';
import { useStyles } from './SideToolbar.styles';
import CommentDraggableIcon from '../CommentDraggableIcon/CommentDraggableIcon.component';
import CancelIcon from '@material-ui/icons/Cancel';
import { PreviewType, SolutionViewMode } from '../../pages/Solution/Solution.component';
import TooltipOneComponent from '../TooltipOne/TooltipOne.component';
import { fill, fillHover } from '../../utils/contrastSvgAttributes';
import { useLayoutContext } from '../../Context/Layout.context';

interface SideToolbarProps {
  mode: SolutionViewMode;
  previewType: PreviewType;
  isToolbarOpen: boolean;
  isThumbnailsOpen: boolean;
  isFullscreen: boolean;
  handleToolbarOpen?: () => void;
  handleThumbnailsOpen?: () => void;
  handleAnnotationsOpen?: () => void;
  onCommentDragStateChange: (isDragging: boolean) => void;
  canAddComment: boolean;
  isAnnotationToolOpen: boolean;
}

export const SideToolbar: React.FC<SideToolbarProps> = (props) => {
  const classes = useStyles();

  const { isAnyDropdownOpen } = useLayoutContext();

  return (
    <div
      id="sideBar"
      className={
        !props.isFullscreen
          ? `${classes.sideToolbar} ${classes.sideToolbarNonFullscreen}`
          : `${classes.sideToolbar} ${classes.sideToolbarFullscreen}`
      }
    >
      <TooltipOneComponent title="Narzędzia" placement="right">
        <div
          onClick={props.handleToolbarOpen}
          className={classes.sideToolbarIcon}
          draggable="false"
          tabIndex={0}
          onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
            if (event.key === 'Enter') {
              isAnyDropdownOpen.current = !props.isToolbarOpen;
              props.handleToolbarOpen && props.handleToolbarOpen();
            }
          }}
        >
          {props.isToolbarOpen ? (
            <ToolsHover fill={fillHover} title="ikona narzędzi" role="img" />
          ) : (
            <Tools fill={fill} aria-label="ikona narzędzi" role="img" />
          )}
        </div>
      </TooltipOneComponent>
      {props.isToolbarOpen && (
        <img style={{ top: '2px' }} className={classes.arrowToolbarIcon} src={Arrow} alt="ikona nawigacji" />
      )}
      <TooltipOneComponent title="Miniatury stron" placement="right">
        <div
          onClick={props.previewType === 'card' ? props.handleThumbnailsOpen : undefined}
          className={classes.sideToolbarIcon}
          style={{ cursor: props.previewType === 'card' ? 'pointer' : 'not-allowed' }}
          draggable="false"
          tabIndex={0}
          onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
            if (event.key === 'Enter') {
              isAnyDropdownOpen.current = props.isThumbnailsOpen && props.previewType === 'card';
              props.handleThumbnailsOpen && props.handleThumbnailsOpen();
            }
          }}
        >
          {props.previewType === 'card' ? (
            <PageHover fill={fill} title="ikona miniatury stron" />
          ) : (
            <>
              <div
                style={{
                  position: 'relative',
                }}
              >
                <CancelIcon className={classes.disabledAction} />
                <Page fill={fill} aria-label="ikona Miniatury stron" />
              </div>
            </>
          )}
        </div>
      </TooltipOneComponent>
      {props.isThumbnailsOpen && (
        <img style={{ top: '49px' }} className={classes.arrowToolbarIcon} src={Arrow} alt="ikona strzałka" />
      )}
      {props.canAddComment && props.mode !== SolutionViewMode.sampleAssessmentGroupAssignment && (
        <CommentDraggableIcon
          className={classes.sideToolbarIcon}
          onCommentDragStateChange={props.onCommentDragStateChange}
        />
      )}
      {props.isAnnotationToolOpen && (
        <TooltipOneComponent title="Adnotacje" placement="right">
          <div
            onClick={props.handleAnnotationsOpen}
            className={classes.sideToolbarIcon}
            draggable="false"
            tabIndex={0}
            onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
              if (event.key === 'Enter') {
                isAnyDropdownOpen.current = !isAnyDropdownOpen.current;
                props.handleAnnotationsOpen && props.handleAnnotationsOpen();
              }
            }}
          >
            <AnnotationIcon fill={fill} title="otwórz panel adnotacji" />
          </div>
        </TooltipOneComponent>
      )}
    </div>
  );
};
